module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('v-icon', [_vm._v("announcement")]), _vm._v("notice\n    ")], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "notice_contents"
  }, _vm._l((_vm.noticeList), function(notice, n) {
    return _c('div', {
      key: n,
      staticClass: "notice_content"
    }, [_c('div', [_vm._v(_vm._s(_vm.parseDateFormat(notice.ymd)))]), _vm._v(" "), _c('div', {
      staticClass: "notice_title",
      on: {
        "click": function($event) {
          return _vm.handleClick(notice)
        }
      }
    }, [_vm._v("\n        " + _vm._s(notice.title) + "\n      ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "pagination_wrap"
  }, [_c('Pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalPageNum": _vm.totalPageNum
    },
    on: {
      "pageChange": _vm.pageChange
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice_header"
  }, [_c('div', [_vm._v("작성일")]), _vm._v(" "), _c('div', [_vm._v("제  목")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52206035","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainScreen/NoticeList.vue
// module id = 847
// module chunks = 1